import { Directive, inject, TemplateRef } from '@angular/core';
import { ICalendarDay } from '../utils/schedule-calendar.utils';

export interface IScheduleCalendarDayContentContext {
  $implicit: ICalendarDay;
  /** Minutes from the start of today */
  nowMinutes: number;
}

/**
 * Marks the template for what's shown on each day of the calendar, positioned
 * within the day's full height
 */
@Directive({
  selector: 'ng-template[appScheduleCalendarDayContent]',
})
export class ScheduleCalendarDayContentDirective {
  readonly templateRef =
    inject<TemplateRef<IScheduleCalendarDayContentContext>>(TemplateRef);

  static ngTemplateContextGuard(
    _directive: ScheduleCalendarDayContentDirective,
    _context: unknown
  ): _context is IScheduleCalendarDayContentContext {
    return true;
  }
}
